export default "__VITE_ASSET__DS44ghaY__"